import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import {
  TerminalListQuery,
  TerminalRepository,
} from '@app/domain/ports/tpv/terminal.repository';
import { TpvTerminal } from '@app/domain/models/tpv/terminal.model';
import { TpvPage } from '@app/domain/models/tpv/tpv-page.model';

/** Mock del directorio de terminales para pruebas sin backend (tpvUseMocks). */
@Injectable()
export class TerminalMockDataSource extends TerminalRepository {
  override getTerminals(
    externalIdMerchant: string,
    query: TerminalListQuery = {},
  ): Observable<TpvPage<TpvTerminal>> {
    const terminals: TpvTerminal[] = [
      { idTerminal: 'mock-terminal-1', externalIdMerchant, companyName: 'Demo 1 SA de CV', merchantName: 'Comercio Demo 1', affiliation: '1234567', os: 'Android 12', lastActivity: '2026-06-09T10:00:00Z', status: 'active', serialNumber: 'P651900030610' },
      { idTerminal: 'mock-terminal-2', externalIdMerchant, companyName: 'Demo 1 SA de CV', merchantName: 'Comercio Demo 1', affiliation: '1234568', os: 'Android 11', lastActivity: '2026-06-08T15:30:00Z', status: 'inactive', serialNumber: 'P651900012757' },
      { idTerminal: 'mock-terminal-3', externalIdMerchant, companyName: 'Demo 1 SA de CV', merchantName: 'Comercio Demo 1', affiliation: '1234569', os: 'Android 13', lastActivity: '2026-06-07T09:15:00Z', status: 'active', serialNumber: 'P651900099999' },
    ];

    return of({
      data: terminals,
      total: terminals.length,
      page: query.page ?? 1,
      limit: query.limit ?? 10,
    }).pipe(delay(300));
  }
}
